import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'Supplier Returned Notes';

const supplierReturnedNotes = [
  {
    matchRegex: '/SupplierReturnedNotes/Detail/:id',
    name: getRouteName(MODULE_NAME, 'Detail'),
    slots: [
      SLOT_KEY.SLOT_V_ADDITION_MENU,
      SLOT_KEY.SLOT_V_SECTION,
      SLOT_KEY.SLOT_SCRIPTS,
    ],
    parentKeys: {
      [SLOT_KEY.SLOT_V_SECTION]: [
        { key: 'srns-detail-tab', label: 'Supplier Returned Notes Detail Tab' },
        { key: 'srns-items-tab', label: 'Supplier Returned Notes Items Tab' },
        { key: 'srns-audit-tab', label: 'Supplier Returned Notes Audit Tab' },
      ],
    },
  },
];

export default supplierReturnedNotes;
